/**
 * MCA M2 Phase 08 / Phase 05 + Session 63 Phase 06
 *
 * Two responsibilities:
 *   (A) Buy-widget summary sync — keep "{size} · {price}" recap inside
 *       mca-pdp-buy-widget__summary in sync with the top price element +
 *       selected Size option. Runs on all viewports.
 *   (B) Mobile sticky ATC bar — show fixed bottom bar after Walls in-flow
 *       Add-to-Cart scrolls off-screen. Mobile only.
 *
 * Walls re-renders the top price element (#price-{section_id}) on every
 * variant:change via section-rendering fetch. We MutationObserver that
 * element and mirror its innerHTML into the summary + sticky-bar price.
 *
 * Note on overflow:hidden body: Walls sets `body { overflow: hidden auto }`,
 * so IntersectionObserver with `root: null` does NOT re-fire reliably here.
 * We use a passive scroll listener + rAF throttle instead.
 */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function init() {
    // --- Cross-viewport: buy-widget summary + sticky bar price mirror ---
    // S65 P05: support MULTIPLE buy widgets on the page (top + bottom) via
    // querySelectorAll. Also mirror the hidden variant id input across all
    // sibling buy forms so either ATC submits the correct variant.
    var topPrice = document.querySelector('[id^="price-template"], [id^="price-"]');
    var summaryPriceEls = document.querySelectorAll('[data-mca-buy-summary-price]');
    var summarySizeEls = document.querySelectorAll('[data-mca-buy-summary-size]');
    var bar = document.querySelector('[data-mca-sticky-atc]');
    var stickyPrice = bar && bar.querySelector('[data-mca-sticky-atc-price]');

    function syncPrice() {
      if (!topPrice) return;
      var sale = topPrice.querySelector('.price__sale .price-item--sale');
      var regular = topPrice.querySelector('.price-item--regular');
      var text = (sale && sale.textContent.trim()) ||
                 (regular && regular.textContent.trim()) ||
                 '';
      if (!text) return;
      if (stickyPrice) stickyPrice.textContent = text;
      summaryPriceEls.forEach(function (el) { el.textContent = text; });
    }

    function syncSize() {
      if (!summarySizeEls.length) return;
      // S65 P06: picker_type flipped from 'dropdown' to 'button' (chip toggle).
      // Read the checked radio's value first; fall back to legacy <select>.
      var txt = '';
      var checked = document.querySelector('variant-radios input[type="radio"][name="Size"]:checked');
      if (checked) {
        txt = checked.value;
      } else {
        var sel = document.querySelector('select[name="options[Size]"]');
        if (sel && sel.selectedIndex >= 0) txt = sel.options[sel.selectedIndex].text;
      }
      if (txt) summarySizeEls.forEach(function (el) { el.textContent = txt; });
    }

    function syncVariantIdAcrossForms() {
      // S68 fix: URL ?variant= is the only reliable source of truth — Walls
      // maintains it via History API on every variant:change. The previous
      // implementation read inputs[0] from form[id^="mca-buy-form-"], but
      // Walls actually writes the variant to its own product-form (Shop Pay
      // installments wrapper) which is NOT matched by that selector, so the
      // mca-buy-widget forms silently kept the initial base variant.
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      if (!m) return;
      var v = m[1];
      document
        .querySelectorAll('form[action*="/cart/add"] input[name="id"]')
        .forEach(function (i) { i.value = v; });
    }

    if (topPrice && (stickyPrice || summaryPriceEls.length)) {
      new MutationObserver(syncPrice).observe(topPrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    if (summarySizeEls.length) {
      document.addEventListener(
        'change',
        function (e) {
          // S65 P06: support both Size dropdown (name='options[Size]') and
          // chip-toggle radios (name='Size') as variant input sources.
          if (e.target && (e.target.name === 'options[Size]' || e.target.name === 'Size')) {
            syncSize();
            // Walls' variant picker writes to the primary form's hidden id
            // input synchronously after this change. Mirror to all sibling
            // forms on next tick so the secondary widget's ATC submits the
            // correct variant.
            setTimeout(syncVariantIdAcrossForms, 0);
          }
        },
        true
      );
      // Initial sync on page load.
      setTimeout(function () { syncSize(); syncVariantIdAcrossForms(); }, 0);
    }

    // S68 fix: Walls dispatches 'variant:change' AFTER its internal state +
    // URL are updated. Listen at the document level (cross-viewport, runs
    // even when there are no Size summary nodes) so the variant id mirror
    // catches every variant transition Walls knows about.
    document.addEventListener('variant:change', syncVariantIdAcrossForms);

    // --- Mobile-only: sticky bottom ATC bar ---
    var MOBILE_QUERY = window.matchMedia('(max-width: 768px)');
    if (!MOBILE_QUERY.matches) return;

    var inFlowAtc = document.querySelector('.product-form__submit');
    if (!bar || !inFlowAtc) return;

    function show() {
      bar.hidden = false;
      bar.setAttribute('data-visible', 'true');
      bar.setAttribute('aria-hidden', 'false');
    }
    function hide() {
      bar.setAttribute('data-visible', 'false');
      bar.setAttribute('aria-hidden', 'true');
    }

    var ticking = false;
    function check() {
      ticking = false;
      var live = document.querySelector('.product-form__submit') || inFlowAtc;
      var rect = live.getBoundingClientRect();
      if (rect.bottom <= 0) show();
      else hide();
    }
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(check);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Bridge bar CTA → in-flow ATC submit.
    var trigger = bar.querySelector('[data-mca-sticky-atc-trigger]');
    if (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var live = document.querySelector('.product-form__submit');
        if (live) live.click();
      });
    }

    // Mirror in-flow ATC label + disabled state on variant change.
    var labelEl = bar.querySelector('[data-mca-sticky-atc-label]');
    function syncFromInFlow() {
      var live = document.querySelector('.product-form__submit');
      if (!live) return;
      if (labelEl) {
        // Walls slide-up animation contract: outer <span> contains TWO inner
        // <span>s with duplicate labels. Use the first inner span only —
        // otherwise we get "Add to Cart Add to Cart" in the sticky bar.
        var inner = live.querySelector('span > span');
        var span = inner || live.querySelector('span');
        if (span) labelEl.textContent = span.textContent.trim();
      }
      if (trigger) {
        if (live.disabled) trigger.setAttribute('disabled', 'disabled');
        else trigger.removeAttribute('disabled');
      }
    }
    document.addEventListener('variant:change', syncFromInFlow);
    syncFromInFlow();

    // Hide bar when cart drawer / overlay opens.
    var bodyObserver = new MutationObserver(function () {
      if (
        document.body.hasAttribute('data-cart-drawer-open') ||
        document.body.classList.contains('overlay-open')
      ) {
        hide();
      }
    });
    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-cart-drawer-open', 'class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
